import React from 'react'
import PropTypes from 'prop-types'
import { Box, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: '0px 10px 10px -5px rgba(0,0,0,0.05)',
    backgroundColor: 'var(--theme-color-surface-d0)',
    padding: '10px',
    borderRadius: 'var(--border-radius-lg)',
    cursor: 'pointer',
    border: 'var(--border-neutral-normal)',
    width: '100%',
    height: '100%',
    position: 'relative',
    zIndex: 100,
    transition: 'border-color .3s ease-in-out',
    '&:hover': {
      border: '2px solid var(--text-color-main)'
    }
  }
}))

const EmptyCard = ({ children }) => {
  const classes = useStyles()
  return (
    <Box className={classes.card} height='100%' width='100%'>
      {children}
    </Box>
  )
}

EmptyCard.propTypes = {
  children: PropTypes.node
}

export default EmptyCard
